<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <!--          <div class="md-autocomplete">-->
          <!--            <md-autocomplete-->
          <!--              class="search"-->
          <!--              v-model="selectedEmployee"-->
          <!--              :md-options="employees"-->
          <!--              :md-open-on-focus="false"-->
          <!--            >-->
          <!--              <label v-if="$route.meta.rtlActive">بحث...</label>-->
          <!--              <label v-else>Search...</label>-->
          <!--            </md-autocomplete>-->
          <!--          </div>-->
          <md-list>
            <md-list-item @click="dashboard">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <li class="md-list-item">
              <a
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                      @click="getNotifications"
                    >
                      <md-icon>notifications</md-icon>
                      <span
                        class="notification"
                        style="font-size: 13px;font-weight: bold;"
                        v-if="notification_count !== 0"
                        >{{ notification_count }}</span
                      >
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li
                        v-for="n in notifications"
                        v-bind:key="n.id"
                        :value="n.id"
                      >
                        <a
                          :href="
                            '/application/update/' + n.relation.application_id
                          "
                          >{{ n.content }}</a
                        >
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item @click="profile">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
            <md-list-item @click="logout">
              <i class="material-icons">login</i>
              <p class="hidden-lg hidden-md">Logout</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      notification_count: 0,
      notifications: [],
      loop_count: 0,
      loop_limit: 50,
      // selectedEmployee: "",
      // employees: [
      //   "Jim Halpert",
      //   "Dwight Schrute",
      //   "Michael Scott",
      //   "Pam Beesly",
      //   "Angela Martin",
      //   "Kelly Kapoor",
      //   "Ryan Howard",
      //   "Kevin Malone"
      // ]
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    getNotificationCount() {
      this.$store
        .getNotificationCount()
        .then(response => {
          this.notification_count = response.data.count;
        })
        .catch(error => {
          var message = error.message;
          this.$notify({
            message: message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
      var cs = this;
      setTimeout(function() {
        if (cs.loop_count < cs.loop_limit) {
          cs.loop_count++;
          cs.getNotificationCount();
        }
      }, 120000);
    },
    getNotifications() {
      this.$store
        .getNotifications()
        .then(response => {
          this.notifications = response.data.results;
          this.notification_count = 0;
        })
        .catch(error => {
          var message = error.message;
          this.$notify({
            message: message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    dashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    profile() {
      this.$router.push({ name: "User Page" });
    },
    logout() {
      this.$store
        .logout()
        .then(response => {
          this.$router.push({ name: "Login" });
        })
        .catch(error => {
          var message = error.message;
          this.$notify({
            message: message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  },
  mounted() {
    this.getNotificationCount();
  }
};
</script>
